import { useCallback } from 'react';
import { useDockviewApi } from '@/app/providers/DockviewApiProvider';
import { TabContext } from '@/entities/tab/model/tab.types';

/**
 * 탭 컨텍스트의 params를 업데이트하는 훅
 */
export function useUpdateTabParams() {
  const api = useDockviewApi();

  const updateTabParams = useCallback(
    (tabId: string | undefined, params: Record<string, unknown>) => {
      if (!api || !tabId) return;

      const panel = api.panels.find((p) => p.id === tabId);
      if (!panel) return;

      const currentContext = panel.params as TabContext | undefined;
      if (!currentContext) return;

      const updatedContext: TabContext = {
        ...currentContext,
        params: {
          ...currentContext.params,
          ...params,
        },
      };

      panel.update({ params: updatedContext });
    },
    [api]
  );

  return { updateTabParams };
}
